module.exports = __webpack_public_path__ + "static/img/UTSC老师_Vincent.25f96b5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/studentLanding/UTSC/UTSC老师_Vincent.png
// module id = dSWM
// module chunks = 0